// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__s1kI1","calendarButtons":"ClockData_calendarButtons__1j9GF"};